import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const corporateLinks = [
    { path: '/hakkimizda', label: t('nav.about') },
    { path: '/faaliyetlerimiz', label: t('nav.activities') },
    { path: '/uygulamalarimiz', label: t('nav.applications') },
    { path: '/referanslarimiz', label: t('nav.references') },
    { path: '/cozum-ortaklarimiz', label: t('nav.partners') },
    { path: '/iletisim', label: t('nav.contact') },
  ];

  const socialLinks = [
    { icon: 'ri-instagram-line', label: 'Instagram', href: '#' },
    { icon: 'ri-youtube-line', label: 'YouTube', href: '#' },
    { icon: 'ri-facebook-line', label: 'Facebook', href: '#' },
    { icon: 'ri-linkedin-line', label: 'LinkedIn', href: '#' },
  ];

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="container-page py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-4">
            <h3 className="text-2xl md:text-3xl font-bold leading-tight mb-6">
              {t('footer.cta')}
            </h3>
            <Link
              to="/iletisim"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <span>İletişime Geçin</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-base font-semibold mb-5 text-background-50">
              {t('footer.corporate')}
            </h4>
            <ul className="flex flex-col gap-3">
              {corporateLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-base font-semibold mb-5 text-background-50">
              {t('footer.social')}
            </h4>
            <ul className="flex flex-col gap-3">
              {socialLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="flex items-center gap-2 text-sm text-background-300 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <i className={`${link.icon} text-base w-5 h-5 flex items-center justify-center`}></i>
                    <span>{link.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-base font-semibold mb-5 text-background-50">
              {t('footer.newsletter')}
            </h4>
            <p className="text-sm text-background-300 mb-4 leading-relaxed">
              {t('footer.newsletterText')}
            </p>
            <form
              data-readdy-form="true"
              action="https://readdy.ai/api/form/d8lt69j97o3u3g1u5i7g"
              method="POST"
              className="flex gap-0"
            >
              <input
                type="email"
                name="email"
                placeholder="E-posta adresiniz"
                required
                className="flex-1 px-4 py-2.5 text-sm bg-foreground-900 border border-foreground-700 rounded-l-lg text-background-50 placeholder:text-background-500 outline-none focus:border-primary-500 transition-colors"
              />
              <button
                type="submit"
                className="px-4 py-2.5 bg-primary-500 text-background-50 rounded-r-lg hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-send-plane-fill text-lg w-5 h-5 flex items-center justify-center"></i>
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="container-page py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-md">
              <i className="ri-flashlight-line text-sm text-background-50"></i>
            </div>
            <span className="text-sm text-background-400">
              {t('footer.copyright')}
            </span>
          </div>
          <div className="flex items-center gap-6 text-sm text-background-400">
            <a href="tel:+902122216628" className="flex items-center gap-2 hover:text-background-200 transition-colors cursor-pointer">
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              +90 212 221 66 28
            </a>
            <a href="mailto:info@erdemirelektrik.com.tr" className="flex items-center gap-2 hover:text-background-200 transition-colors cursor-pointer">
              <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
              info@erdemirelektrik.com.tr
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}